import { LoadableElement } from '@99designs/common/components/LoadableElement';
import {
    CreateBrief as CreateBriefInterface,
    CreateBriefVariables,
} from '__generated__/CreateBrief';
import { StructuredBriefFieldsInput } from '__generated__/types';
import { BriefFieldsRedirect } from 'projects/routes';
import { parseQueryString } from 'projects/routes/BriefEntry';
import React, { useEffect } from 'react';
import { useMutation } from 'react-apollo';
import { useLocation } from 'react-router';
import mutation from './CreateBrief.graphql';

export interface Props {
    fields: StructuredBriefFieldsInput;
}

export function useCreateBrief() {
    return useMutation<CreateBriefInterface, CreateBriefVariables>(mutation);
}

export default function CreateBrief({ fields }: Props) {
    const location = useLocation();
    const { designerId } = parseQueryString(location.search);
    const [createBrief, { error, data }] = useMutation<CreateBriefInterface, CreateBriefVariables>(
        mutation
    );

    useEffect(() => {
        const designerIds = designerId ? [designerId] : [];
        createBrief({ variables: { fields, designerIds } });
    }, []);

    if (error) {
        throw error;
    }

    if (data) {
        return <BriefFieldsRedirect brief={data.createStructuredBrief} push={false} />;
    }

    return <LoadableElement variations={['fade-in']} isLoading={true} />;
}
